// WhatsApp open helper.
//
// If the Deskte WhatsApp extension (v1.0.3+) is installed, it switches the
// chat inside the WhatsApp Web tab the user already has open — no new tab per
// client. The extension's bridge content script (on app.deskte.com) announces
// itself via postMessage; we route clicks through it when present.
//
// If the extension isn't installed/active, we fall back to opening
// web.whatsapp.com in a single named tab (old behaviour).

let extReady = false;

if (typeof window !== 'undefined') {
  window.addEventListener('message', (e) => {
    if (e.source !== window) return;
    const d = e.data;
    if (d && d.source === 'deskte-wa-ext' && d.type === 'ready') extReady = true;
  });
  // Ping in case the extension's bridge loaded before this module did; the
  // bridge also announces on its own load, so both orders are covered.
  //
  // Target origin is our own, never '*' (auditoría 2026-08-14, semgrep
  // wildcard-postmessage-configuration). The bridge content script runs on
  // app.deskte.com, i.e. this same origin, so it still receives these — but a
  // cross-origin iframe embedded in the page no longer can.
  try { window.postMessage({ source: 'deskte-crm', type: 'wa-ping' }, window.location.origin); } catch (e) { /* ignore */ }
}

/** True if the Deskte WhatsApp extension is present (reuses the open tab). */
export function whatsAppExtensionReady() {
  return extReady;
}

/**
 * Open a client's WhatsApp chat.
 * @param {string} phone - any format; non-digits are stripped.
 * @param {string} [text] - optional pre-filled message.
 * @returns {boolean} false if there's no usable phone number.
 */
export function openWhatsApp(phone, text) {
  const waPhone = String(phone == null ? '' : phone).replace(/\D/g, '');
  if (!waPhone) return false;
  const body = text ? String(text).trim() : '';
  if (extReady) {
    // Extension switches the chat in the already-open WhatsApp Web tab.
    // Own origin, never '*': this payload carries the client's phone number
    // and message body, so a '*' target let any cross-origin iframe on the
    // page read PHI-adjacent data (auditoría 2026-08-14).
    window.postMessage(
      { source: 'deskte-crm', type: 'open-wa-chat', phone: waPhone, text: body },
      window.location.origin
    );
    return true;
  }
  // Fallback: single named tab. web.whatsapp.com/send skips the wa.me
  // "Continue to Chat" page; the fixed window name reuses one tab where the
  // browser allows it.
  const url = 'https://web.whatsapp.com/send?phone=' + waPhone + (body ? '&text=' + encodeURIComponent(body) : '');
  window.open(url, 'deskteWhatsApp');
  return true;
}
